import type { ComponentProps } from "react";
import BaseActionButton from "./BaseActionButton";

type AddButtonProps = Omit<
    ComponentProps<typeof BaseActionButton>,
    "iconType" | "testId" | "buttonType" | "label" | "loadingText"
> & {
    label?: string;
    loadingText?: string;
    buttonType?: "submit" | "button";
    variant?: ComponentProps<typeof BaseActionButton>["variant"];
};

const AddButton = ({
    label = "Add",
    loadingText = "Adding...",
    buttonType = "button",
    variant = "secondary",
    ...props
}: AddButtonProps) => {
    return (
        <BaseActionButton
            label={label}
            loadingText={loadingText}
            iconType="add"
            testId="add-button"
            buttonType={buttonType}
            variant={variant}
            {...props}
        />
    );
};

export default AddButton;
